import { render, staticRenderFns } from "./App.vue?vue&type=template&id=042a1266&"
import script from "../src/js/main.vue?vue&type=script&lang=js&"
export * from "../src/js/main.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"
import style1 from "../src/css/main.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./App.vue?vue&type=custom&index=0&blockType=span"
if (typeof block0 === 'function') block0(component)

export default component.exports